import { render, staticRenderFns } from "./Leirikoski.vue?vue&type=template&id=03fb56f6&scoped=true"
import script from "./Leirikoski.vue?vue&type=script&lang=js"
export * from "./Leirikoski.vue?vue&type=script&lang=js"
import style0 from "./Leirikoski.vue?vue&type=style&index=0&id=03fb56f6&prod&lang=scss&scoped=true"
import style1 from "./Leirikoski.vue?vue&type=style&index=1&id=03fb56f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb56f6",
  null
  
)

export default component.exports